import createSimpleReducers from '../Shared/ducks/createSimpleReducers'
const ducks = createSimpleReducers('Location')

export default ducks
